const TYPE = 'aggregation.noFilter';
export default {
  id: 'molten.aggregation.NoFilterClickAction',
  type: TYPE,
  onClick(data, context) {
    const {
      clientProps: {
        onFilterChange
      }
    } = context;
    onFilterChange({
      data: 'filterBar',
      value: null
    });
  }
};